module.exports = __webpack_public_path__ + "img/gears.6618645b.svg";